import { Request } from "@xt/xtbase";

const { XtAxios4 } = Request;

const CFDURL = "/sapi/v4/cfd/";

// 按保证金算数量（保证金含手续费），接口反算数量保证占用保证金+手续费不超过传入的 margin；路径与开仓一致用 positions 子路径
export function post_cfd_calcQuantity(config?) {
  return XtAxios4.post(CFDURL + `positions/calc-quantity`, null, config);
}

// 按数量算保证金（含手续费），返回占用保证金、手续费、总扣款；路径与开仓一致
export function post_cfd_calcMargin(config?) {
  return XtAxios4.post(CFDURL + `positions/calc-margin`, null, config);
}

// CFD 开仓
export function post_cfd_openPosition(config?) {
  // 和其他 API 保持一致：第二个参数传 null，data 放在 config 中
  return XtAxios4.post(CFDURL + `positions/open`, null, config);
}

// CFD 平仓
export function post_cfd_closePosition(config?) {
  return XtAxios4.post(CFDURL + `positions/close`, null, config);
}

// CFD 一键平仓
export function post_cfd_closeAllPositions(config?) {
  return XtAxios4.post(CFDURL + `positions/close-all`, null, config);
}

// CFD 持仓查询
export function get_cfd_positions(config?) {
  return XtAxios4.get(CFDURL + `positions`, config);
}

// CFD 历史订单查询
export function get_cfd_orders_history(config?) {
  return XtAxios4.get(CFDURL + `orders/history`, config);
}

// CFD 历史仓位查询
export function get_cfd_positions_history(config?) {
  return XtAxios4.get(CFDURL + `positions/history`, config);
}

// CFD 当前委托查询
export function get_cfd_orders(config?) {
  return XtAxios4.get(CFDURL + `orders`, config);
}

// CFD 修改持仓过夜状态
export function put_cfd_positionKeep(positionId: string, config?) {
  return XtAxios4.put(CFDURL + `positions/${positionId}/keep`, null, config);
}

// CFD 修改止盈止损
export function put_cfd_positionTpSl(positionId: string, config?) {
  return XtAxios4.put(CFDURL + `positions/${positionId}/tp-sl`, null, config);
}

// CFD 取消订单
export function post_cfd_cancelOrder(orderId: string, config?) {
  return XtAxios4.post(CFDURL + `orders/${orderId}/cancel`, null, config);
}

// CFD 取消所有订单
export function post_cfd_cancelAllOrders(config?) {
  return XtAxios4.post(CFDURL + `orders/cancel-all`, null, config);
}

// CFD 资金记录查询
export function get_cfd_fund_records(config?) {
  return XtAxios4.get(CFDURL + `fund-records`, config);
}

